/**
 * Known `localStorage` keys used by FormDialog-style 24h draft persistence
 * (CLAUDE.md's "Type 1" FormDialog rule) across the app. None of these are
 * tenant-scoped in the key itself — a draft saved under one tenant silently
 * restores under whichever tenant is active next time the same browser
 * opens that form. Confirmed bug (2026-07-30): a stale `flow_type_id` from
 * a previous tenant survived a manager tenant-switch AND a logout/login as
 * a different tenant's user, submitting a `CROSS_TENANT_REFERENCE` error on
 * collection draft save. Call this on every tenant-context change (logout,
 * manager switch) so no draft can leak across tenants.
 */
const LOCAL_DRAFT_KEYS = [
  'vanagreen:draft_collection_new',
  'support-new-ticket',
  'draft:invoicing:create',
  'pickup-order-create',
] as const;

export function clearLocalDrafts(): void {
  for (const key of LOCAL_DRAFT_KEYS) {
    localStorage.removeItem(key);
  }
}
